import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-pdf-loading',
  templateUrl: './pdf-loading.component.html',
  styleUrls: ['./pdf-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PdfLoadingComponent {}
